import React, { createContext, useContext, useState } from 'react';
import { api } from '../api/client';

const AuthContext = createContext(null);

function readAdmin() {
  try {
    const saved = sessionStorage.getItem('revival_admin_user');
    return saved ? JSON.parse(saved) : null;
  } catch {
    sessionStorage.removeItem('revival_admin_user');
    return null;
  }
}

export function AuthProvider({ children }) {
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    return Boolean(sessionStorage.getItem('revival_admin_token'));
  });
  const [admin, setAdmin] = useState(readAdmin);

  const login = async (username, password) => {
    try {
      const result = await api.login({ username, password });
      setIsAuthenticated(true);
      setAdmin(result.admin);
      sessionStorage.setItem('revival_admin_token', result.token);
      sessionStorage.setItem('revival_admin_user', JSON.stringify(result.admin));
      return { success: true };
    } catch (error) {
      return { success: false, error: error.message };
    }
  };

  const logout = () => {
    setIsAuthenticated(false);
    setAdmin(null);
    sessionStorage.removeItem('revival_admin_token');
    sessionStorage.removeItem('revival_admin_user');
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, admin, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
